/**
 * Created by fruysshaert on 06/03/2017.
 */
import { Injectable } from '@angular/core';

import { StorageService } from '../baseBtl/base/services/storage.service';

@Injectable({
    providedIn: 'root',
})
export class ContextStorageService extends StorageService {
    public KEY: { [index: string]: string } = {
        BROWSE_CONTEXT: 'browse_context',
        PROMO_CONTEXT: 'promo_context',
    };

    protected prefix: string = 'context_';

    constructor() {
        super();
        Object.keys(this.KEY).forEach((key) => this.sessionStorageKeys.push(this.KEY[key]));
    }
}
